import React, { useEffect } from "react";

export const Press = (props) => {
  useEffect(() => {
    // Load Instagram embed script
    const script = document.createElement('script');
    script.src = '//www.instagram.com/embed.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div id="press">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 text-center">
            <div className="section-title">
              <h2>PRESSESTIMMEN</h2>
            </div>
          </div>
        </div>

        {/* Radio Section */}
        <div className="row mb-5">
          <div className="col-xs-12">
            <h3 className="text-center mb-4">Radio</h3>
            
            {/* France Culture Podcasts */}
            <div className="podcast-container text-center">
              <h4 className="text-center mb-3">France Culture - Les Talmudiques: Survivre à Terezin (19.03.2023) (2/2)</h4>
              <div style={{ 
                maxWidth: "540px", 
                margin: "0 auto",
                borderRadius: "3px",
                boxShadow: "0 0 1px 0 rgba(0,0,0,0.5), 0 1px 10px 0 rgba(0,0,0,0.15)",
                overflow: "hidden"
              }}>
                <a 
                  href="https://www.radiofrance.fr/franceculture/podcasts/talmudiques/survivre-a-terezin-2-2-bedrich-fritta-et-l-art-d-heriter-9981768" 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  <img 
                    src="/img/press/helios2.jpg"
                    alt="France Culture - Les Talmudiques: Survivre à Terezin (2/2)"
                    style={{
                      width: "100%",
                      height: "auto",
                      display: "block"
                    }}
                  />
                </a>
              </div>
            </div>

            <div className="podcast-container text-center">
              <h4 className="text-center mb-3">France Culture - Les Talmudiques: Survivre à Terezin (12.03.2023) (1/2)</h4>
              <div style={{ 
                maxWidth: "540px", 
                margin: "0 auto",
                borderRadius: "3px",
                boxShadow: "0 0 1px 0 rgba(0,0,0,0.5), 0 1px 10px 0 rgba(0,0,0,0.15)",
                overflow: "hidden"
              }}>
                <a 
                  href="https://www.radiofrance.fr/franceculture/podcasts/talmudiques/survivre-a-terezin-1-2-dessinateurs-en-resistance-3139461" 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  <img 
                    src="/img/press/helios1.jpg"
                    alt="France Culture - Les Talmudiques: Survivre à Terezin (1/2)"
                    style={{
                      width: "100%",
                      height: "auto",
                      display: "block"
                    }}
                  />
                </a>
              </div>
            </div>

            {/* French Radio Interview */}
            <div className="audio-container text-center">
              <h4 className="text-center mb-3">France Culture - Pour Tommy (18.01.2023)</h4>
              <audio 
                controls
                style={{ 
                  maxWidth: "540px", 
                  width: "100%",
                  margin: "0 auto",
                  borderRadius: "3px",
                  boxShadow: "0 0 1px 0 rgba(0,0,0,0.5), 0 1px 10px 0 rgba(0,0,0,0.15)"
                }}
              >
                <source src="/img/press/Tommy_Pour-Tommy_1944_Sortie-France_Peintre-Holocauste_Fils.mp3" type="audio/mpeg" />
                Your browser does not support the audio element.
              </audio>
            </div>

            <div className="audio-container text-center">
              <h4 className="text-center mb-3">SWR2 - Kultur aktuell (16.5.2013)</h4>
              <audio 
                controls
                style={{ 
                  maxWidth: "540px", 
                  width: "100%",
                  margin: "0 auto",
                  borderRadius: "3px",
                  boxShadow: "0 0 1px 0 rgba(0,0,0,0.5), 0 1px 10px 0 rgba(0,0,0,0.15)"
                }}
              >
                <source src="/img/press/SWR2_Kultur_aktuell_16_5_2013.mp3" type="audio/mpeg" />
                Your browser does not support the audio element.
              </audio>
            </div>
          </div>
        </div>

        {/* Videos Section */}
        <div className="row mb-5">
          <div className="col-xs-12">
            <h3 className="text-center mb-4">Filme und Videos</h3>
            
            {/* ARTE Video */}
            <h4 className="text-center mb-3">ARTE - Kunst aus dem Todeslager (23.04.2023)</h4>
            <div className="video-container mb-5">
              <video 
                controls
                width="100%"
                style={{ maxWidth: "540px", margin: "0 auto 30px" }}
              >
                <source src="./img/press/ARTE_instagram_reel.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>

            {/* ARD Video Embed */}
            <div className="video-container">
              <iframe
                title="MDR Dok: Kunst aus dem Todeslager"
                width="100%"
                style={{ 
                  maxWidth: "540px", 
                  height: "304px", 
                  margin: "0 auto",
                  border: "none",
                  borderRadius: "3px",
                  boxShadow: "0 0 1px 0 rgba(0,0,0,0.5), 0 1px 10px 0 rgba(0,0,0,0.15)"
                }}
                src="https://www.ardmediathek.de/embed/Y3JpZDovL21kci5kZS9zZW5kdW5nLzI4MjA0MC80ODg3MjctNDc0NjI4"
                allowFullScreen
              ></iframe>
            </div>

            {/* ARD Tagesschau Video */}
            <h4 className="text-center mb-3">Tagesschau - Zeichnungen aus dem Ghetto Theresienstadt (15.05.2013)</h4>
            <div className="video-container mb-5">
              <video 
                controls
                width="100%"
                style={{ maxWidth: "540px", margin: "0 auto 30px" }}
              >
                <source src="/img/press/20130515_tagesschau.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        </div>

        {/* Press Articles Section */}
        <div className="row mb-5">
          <div className="col-xs-12">
            <h3 className="text-center mb-4">Presse</h3>

            {/* 2025: Münster Exhibition Article */}
            <div className="press-article">
              <h4>Ausstellungseröffnung: "Koffer packen für Tommy: Sich erinnern und nie vergessen"</h4>
              <p className="press-date">27. Januar 2025 | Bezirksregierung Münster</p>
              <div className="press-content">
                <div className="press-image">
                  <img 
                    src="/img/press/muenster_eroeffnung.jpg" 
                    alt="Ausstellungseröffnung in Münster" 
                    className="img-fluid"
                  />
                  <p className="image-caption">Ausstellungseröffnung in der Bezirksregierung Münster, Januar 2025</p>
                </div>
                <p>Die Bezirksregierung Münster zeigt vom 27. Januar bis zum 14. Februar 2025 die Fotoausstellung "Koffer packen für Tommy". Die Ausstellung dokumentiert eine Gedenkstättenfahrt der Schüler:innen des Anette-von-Droste-Hülshoff-Gymnasiums nach Theresienstadt und Lidice in Tschechien.</p>
                <a 
                  href="https://www.bezreg-muenster.de/de/presse/2025/2025-01-27_ausstellungseroeffnung/index.html" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="btn btn-custom"
                >
                  Zum Artikel
                </a>
              </div>
            </div>

            {/* 2024: Annette-von-Droste-Hülshoff-Gymnasium Article */}
            <div className="press-article">
              <h4>Das "Tommy-Projekt" - Ein Erinnerungsprojekt aus der Mittelstufe</h4>
              <p className="press-date">2024 | Annette-von-Droste-Hülshoff-Gymnasium Münster</p>
              <div className="press-content">
                <div className="press-image">
                  <img 
                    src="/img/press/muenster_huelshoff_gymnasium.jpg" 
                    alt="Das Tommy-Projekt am Annette-von-Droste-Hülshoff-Gymnasium" 
                    className="img-fluid"
                  />
                  <p className="image-caption">Das Tommy-Projekt am Annette-von-Droste-Hülshoff-Gymnasium</p>
                </div>
                <p>Dem jüdischen Gebot "Sachor we lo tischkach" (Erinnere dich und vergiss nie!) folgend begannen die Schüler:innen im Januar 2023 ein fächerübergreifendes Holocaust-Education-Projekt. Sie beschäftigten sich mit dem Buch "Für Tommy zum 3. Geburtstag", welches der Künstler Bedrich Fritta im Ghetto Theresienstadt schrieb und illustrierte. Ein leerer, 100 Jahre alter Koffer diente als visueller Impuls, um historisches Denken und Entscheiden zu simulieren: Was hättet ihr eingepackt?</p>
                <a 
                  href="https://www.annette-gymnasium.de/das-tommy-projekt/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="btn btn-custom"
                >
                  Zum Artikel
                </a>
              </div>
            </div>

            {/* 2023 - WDR Article */}
            <div className="press-article">
              <h4>Einzigartiges Bilderbuch aus KZ im Schulunterricht</h4>
              <p className="press-date">25. April 2023 - WDR Nachrichten</p>
              <div className="press-content">
                <div className="press-image">
                  <img 
                    src="/img/press/muenster_school_event.jpg" 
                    alt="Schulveranstaltung in Münster" 
                    className="img-fluid"
                  />
                  <p className="image-caption">Schulveranstaltung in Münster | April 2023</p>
                </div>
                <p>Für David Fritta-Haas ist das Bilderbuch, das sein Großvater im KZ Theresienstadt 1944 gezeichnet hatte, von unschätzbarem Wert. "Die Zeitzeugen sind inzwischen Greise, in fünf bis zehn Jahren wird es keine KZ-Überlebenden mehr geben", sagt er. Deshalb ist es ihm wichtig, als "Zweitzeuge" aufzutreten, damit die Geschichte der Juden im Holocaust nicht vergessen wird.</p>
                <a 
                  href="https://www1.wdr.de/nachrichten/westfalen-lippe/kinderbuch-kz-theresienstadt-gerettet-106.html" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="btn btn-custom"
                >
                  Zum Artikel
                </a>
              </div>
            </div>

            {/* 2023: Jüdische Allgemeine Article */}
            <div className="press-article">
              <h4>Kinderbuch für Tommy</h4>
              <p className="press-date">27. April 2023 | Jüdische Allgemeine</p>
              <div className="press-content">
                <div className="press-image">
                  <img 
                    src="/img/press/juedische_allgemeine.jpg" 
                    alt="Kinderbuch für Tommy" 
                    className="img-fluid"
                  />
                  <p className="image-caption">Kinderbuch "Für Tommy" | April 2023</p>
                </div>
                <p>Der Künstler Bedřich Fritta zeichnete im KZ Theresienstadt ein Bilderbuch für seinen dreijährigen Sohn Tommy. Heute ist das Buch ein wichtiges Zeugnis der Schoah. David Haas, der Enkel des Künstlers, erzählt die Geschichte seiner Familie.</p>
                <a 
                  href="https://www.juedische-allgemeine.de/unsere-woche/kinderbuch-fuer-tommy/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="btn btn-custom"
                >
                  Zum Artikel
                </a>
              </div>
            </div>

            {/* 2013 - 2014:  Jewish Museum Berlin Exhibition Article */}
            <div className="press-article">
              <h4>Bedřich Fritta: Zeichnungen aus dem Ghetto Theresienstadt</h4>
              <p className="press-date">2013 - 2014 | Jüdisches Museum Berlin</p>
              <div className="press-content">
                <div className="press-image">
                  <img 
                    src="./img/press/juedisches_museum_berlin_fritta_visual.jpg" 
                    alt="Bedřich Fritta, Varieté, 1943/44" 
                    className="img-fluid"
                  />
                  <p className="image-caption">Bedřich Fritta, Varieté, 1943/44. Tusche, Feder und Pinsel, laviert</p>
                </div>
                <p>Die Ausstellung im Jüdischen Museum Berlin zeigt die künstlerische Qualität der Zeichnungen von Bedřich Fritta (1906-1944), die zwischen 1942 und 1944 im Konzentrationslager "Ghetto Theresienstadt" entstanden sind. Der Fokus liegt auf den künstlerischen Mitteln, mit denen Frittas Zeichnungen den Lageralltag deuten und kommentieren.</p>
                <a 
                  href="https://www.jmberlin.de/ausstellung-bedrich-fritta" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="btn btn-custom"
                >
                  Zum Artikel
                </a>
              </div>
            </div>

            {/* 2013: Jewish Museum Berlin - Tommy's Book Exhibition */}
            <div className="press-article">
              <h4>"Für Tommy zum 3. Geburtstag"</h4>
              <p className="press-date">17. Mai - 29. September 2013 | Jüdisches Museum Berlin</p>
              <div className="press-content">
                <div className="press-image">
                  <img 
                    src="./img/press/juedisches_museum_berlin_kinderbuch.jpg" 
                    alt="Bilderbuch für Tommy" 
                    className="img-fluid"
                  />
                  <p className="image-caption">Bedřich Fritta, "Für Tommy zum dritten Geburtstag in Theresienstadt 22.1.1944", 1943/44</p>
                </div>
                <p>Anders als Frittas Tuschezeichnungen zeigt sein für den Sohn gemaltes Buch eine leichte, fröhliche, in nur wenigen schwungvollen Strichen und in Farbe erfasste Bilderwelt. In farbigen Bildern schildert Fritta den Alltag seines Sohnes in Theresienstadt und zeigt eine imaginäre Welt mit Phantasien von gemeinsamen Reisen durch fremde, exotische Länder. Das Buch wurde im Ghetto versteckt und nach der Befreiung wiedergefunden.</p>
                <a 
                  href="https://www.jmberlin.de/fritta/de/bilderbuch-fuer-tommy.php"
                  target="_blank"
                  rel="noopener noreferrer" 
                  className="btn btn-custom"
                >
                  Zum Artikel
                </a>
              </div>
            </div>

            {/* 2013: Süddeutsche Zeitung Article */}
            <div className="press-article">
              <h4>Todesmetaphern aus Theresienstadt</h4>
              <p className="press-date">23. Mai 2013 | Süddeutsche Zeitung</p>
              <div className="press-content">
                <div className="press-image">
                  <img 
                    src="/img/press/sueddeutsche.jpg"
                    alt="Ausstellung im Jüdischen Museum Berlin" 
                    className="img-fluid"
                  />
                  <p className="image-caption">Ausstellung "Bedřich Fritta - Zeichnungen aus dem Ghetto Theresienstadt" | Mai 2013</p>
                </div>
                <p>Mit ganzer Wucht trifft den Besucher die Ausstellung "Bedřich Fritta - Zeichnungen aus dem Ghetto Theresienstadt". Der Karikaturist hat mit seinen wütenden Tusche-Zeichnungen ganze Arbeit geleistet. In seiner Überzeichnung und Stilisierung wird das Ausmaß der Verlogenheit, Täuschung und Brutalität sichtbar, die allein in diesem Ghetto mehr als 100.000 Menschen das Leben gekostet hat.</p>
                <a 
                  href="https://www.sueddeutsche.de/kultur/ausstellung-im-juedischen-museum-berlin-todesmetapher-aus-theresienstadt-1.1677063"
                  target="_blank"
                  rel="noopener noreferrer" 
                  className="btn btn-custom"
                >
                  Zum Artikel
                </a>
              </div>
            </div>

            {/* 2013: Mannheimer Morgen Article */}
            <div className="press-article">
              <h4>Kinderbuch als einziges Vermächtnis</h4>
              <p className="press-date">2013 | Mannheimer Morgen</p>
              <div className="press-content">
                <div className="press-image">
                  <img 
                    src="/img/press/mannheimer_morgen.jpg"
                    alt="Kinderbuch als einziges Vermächtnis" 
                    className="img-fluid"
                  />
                  <p className="image-caption">Kinderbuch "Für Tommy" | 2013</p>
                </div>
                <p>Ein Bilderbuch als letztes Geschenk eines Vaters an seinen Sohn: Die Geschichte von Bedřich Fritta und seinem Sohn Tommy berührt bis heute. Der Mannheimer David Haas bewahrt das Vermächtnis seines Großvaters.</p>
                <a 
                  href="https://www.mannheimer-morgen.de/orte/mannheim_artikel,-mannheim-kinderbuch-als-einziges-vermaechtnis-_arid,508375.html"
                  target="_blank"
                  rel="noopener noreferrer" 
                  className="btn btn-custom"
                >
                  Zum Artikel
                </a>
              </div>
            </div>

            {/* 1985: Der Spiegel Article */}
            <div className="press-article">
              <h4>Jenseits der Mauer</h4>
              <p className="press-date">15. September 1985 | Der Spiegel</p>
              <div className="press-content">
                <div className="press-image">
                  <img 
                    src="/img/press/spiegel.jpg"
                    alt="Der Spiegel Artikel: Jenseits der Mauer" 
                    className="img-fluid"
                  />
                  <p className="image-caption">Spiegel Artikel von 1985</p>
                </div>
                <p>Ein im Konzentrationslager Theresienstadt gemaltes Kinderbuch für einen Dreijährigen hat jetzt einen deutschen Verlag gefunden. Es sollte nur das erste in einer langen Reihe von Büchern sein, die der Vater ihm malen wollte. Es war auch das letzte. Das Buch "Für Tommy zum dritten Geburtstag" ist gestaltet wie eine heitere und sinnliche Bildergalerie, mit der ein Vater einen Schutzwall gegen die entsetzliche Wirklichkeit, eine Fluchtburg vor dem unbeschreiblichen Elend des Lagers errichtete.</p>
                <a 
                  href="https://www.spiegel.de/kultur/jenseits-der-mauer-a-0a316c64-0002-0001-0000-000013515804"
                  target="_blank"
                  rel="noopener noreferrer" 
                  className="btn btn-custom"
                >
                  Zum Artikel
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Instagram Section */}
        <div className="row">
          <div className="col-xs-12">
            <h3 className="text-center mb-4">Social Media</h3>
            <div className="instagram-container">
              <blockquote
                className="instagram-media"
                data-instgrm-captioned
                data-instgrm-permalink="https://www.instagram.com/p/4YW7nhQViQ/?utm_source=ig_embed&amp;utm_campaign=loading"
                data-instgrm-version="14"
                style={{
                  background: "#FFF",
                  border: "0",
                  borderRadius: "3px",
                  boxShadow: "0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15)",
                  margin: "1px",
                  maxWidth: "540px",
                  minWidth: "326px",
                  padding: "0",
                  width: "calc(100% - 2px)"
                }}
              ></blockquote>
            </div>
          </div>
        </div>

        {/* Books Section */}
        <div className="row mb-5">
          <div className="col-xs-12">
            <h3 className="text-center mb-4">Bücher</h3>
            {/* 2024: Das glückliche Waisenkind */}
            <div className="book-container text-center">
              <a 
                href="https://www.hentrichhentrich.de/book-thomas-fritta-haas.html" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{
                  display: "inline-block",
                  margin: "20px auto"
                }}
              >
                <img 
                  src="/img/book/buch_glueckliche_waisenkind.jpg"
                  alt="Thomas Fritta-Haas - Das glückliche Waisenkind"
                  style={{
                    maxWidth: "300px",
                    width: "100%",
                    height: "auto",
                    borderRadius: "3px",
                    boxShadow: "0 0 1px 0 rgba(0,0,0,0.5), 0 1px 10px 0 rgba(0,0,0,0.15)"
                  }}
                />
              </a>
              <p style={{ maxWidth: "540px", margin: "0 auto", color: "#666" }}>
                Thomas Fritta-Haas - Das glückliche Waisenkind<br />
                Erschienen im Hentrich & Hentrich Verlag, 2024
              </p>
            </div>

            {/* 2024: Pour Tommy */}
            <div className="book-container text-center">
              <a 
                href="https://www.fr.fnac.ch/a17150453/Helios-Azoulay-Pour-Tommy" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{
                  display: "inline-block",
                  margin: "20px auto"
                }}
              >
                <img 
                  src="/img/book/buch_pour_tommy.jpg"
                  alt="Pour Tommy"
                  style={{
                    maxWidth: "300px",
                    width: "100%",
                    height: "auto",
                    borderRadius: "3px",
                    boxShadow: "0 0 1px 0 rgba(0,0,0,0.5), 0 1px 10px 0 rgba(0,0,0,0.15)"
                  }}
                />
              </a>
              <p style={{ maxWidth: "540px", margin: "0 auto", color: "#666" }}>
                Pour Tommy<br />
                Erschienen bei Rocher Eds Du, 2024
              </p>
            </div>

            {/* 2015: BLZ Edition */}
            <div className="book-container text-center">
              <a 
                href="https://www.blz.bayern.de/fuer-tommy-zum-dritten-geburtstag-in-theresienstadt_p_165.html" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{
                  display: "inline-block",
                  margin: "20px auto"
                }}
              >
                <img 
                  src="/img/book/buch_tommy_pustet.jpg"
                  alt="Für Tommy zum dritten Geburtstag in Theresienstadt"
                  style={{
                    maxWidth: "300px",
                    width: "100%",
                    height: "auto",
                    borderRadius: "3px",
                    boxShadow: "0 0 1px 0 rgba(0,0,0,0.5), 0 1px 10px 0 rgba(0,0,0,0.15)"
                  }}
                />
              </a>
              <p style={{ maxWidth: "540px", margin: "0 auto", color: "#666" }}>
                Für Tommy zum dritten Geburtstag in Theresienstadt<br />
                Erschienen bei der Bayerischen Landeszentrale für politische Bildungsarbeit, 2015
              </p>
            </div>

            {/* 2000: Ivan Klima Edition */}
            <div className="book-container text-center">
              <a 
                href="https://www.abebooks.com/signed-first-edition/Fairy-Tale-Real-Ivan-Klima-Jewish/31794522743/bd" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{
                  display: "inline-block",
                  margin: "20px auto"
                }}
              >
                <img 
                  src="/img/book/buch_tommy_klima.jpg"
                  alt="This is Not a Fairy Tale - it's Real!"
                  style={{
                    maxWidth: "300px",
                    width: "100%",
                    height: "auto",
                    borderRadius: "3px",
                    boxShadow: "0 0 1px 0 rgba(0,0,0,0.5), 0 1px 10px 0 rgba(0,0,0,0.15)"
                  }}
                />
              </a>
              <p style={{ maxWidth: "540px", margin: "0 auto", color: "#666" }}>
                This is Not a Fairy Tale - it's Real!<br />
                Erschienen im Jüdischen Museum in Prag, 2000
              </p>
            </div>

            {/* 1999: Yad Vashem Edition */}
            <div className="book-container text-center">
              <a 
                href="https://store.yadvashem.org/en/tommy-56" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{
                  display: "inline-block",
                  margin: "20px auto"
                }}
              >
                <img 
                  src="/img/book/buch_tommy_yad_vashem.jpg"
                  alt="Für Tommy zum dritten Geburtstag in Theresienstadt"
                  style={{
                    maxWidth: "300px",
                    width: "100%",
                    height: "auto",
                    borderRadius: "3px",
                    boxShadow: "0 0 1px 0 rgba(0,0,0,0.5), 0 1px 10px 0 rgba(0,0,0,0.15)"
                  }}
                />
              </a>
              <p style={{ maxWidth: "540px", margin: "0 auto", color: "#666" }}>
                Für Tommy zum dritten Geburtstag in Theresienstadt<br />
                Erschienen im Yad Vashem, 1999
              </p>
            </div>

            {/* 1985: Neske Edition */}
            <div className="book-container text-center">
              <a 
                href="https://www.amazon.de/Tommy-dritten-Geburtstag-Theresienstadt-22-1-1944/dp/378850269X" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{
                  display: "inline-block",
                  margin: "20px auto"
                }}
              >
                <img 
                  src="/img/book/buch_tommy_neske.jpg"
                  alt="Für Tommy zum dritten Geburtstag in Theresienstadt"
                  style={{
                    maxWidth: "300px",
                    width: "100%",
                    height: "auto",
                    borderRadius: "3px",
                    boxShadow: "0 0 1px 0 rgba(0,0,0,0.5), 0 1px 10px 0 rgba(0,0,0,0.15)"
                  }}
                />
              </a>
              <p style={{ maxWidth: "540px", margin: "0 auto", color: "#666" }}>
                Für Tommy zum dritten Geburtstag in Theresienstadt<br />
                Erschienen im Neske Verlag, 1985
              </p>
            </div>

            {/* 1985: Der Hölle entronnen */}
            <div className="book-container text-center">
              <a 
                href="https://amzn.eu/d/aCTJIod" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{
                  display: "inline-block",
                  margin: "20px auto"
                }}
              >
                <img 
                  src="/img/book/buch_hoelle_entronnen.jpg"
                  alt="Der Hölle entronnen"
                  style={{
                    maxWidth: "300px",
                    width: "100%",
                    height: "auto",
                    borderRadius: "3px",
                    boxShadow: "0 0 1px 0 rgba(0,0,0,0.5), 0 1px 10px 0 rgba(0,0,0,0.15)"
                  }}
                />
              </a>
              <p style={{ maxWidth: "540px", margin: "0 auto", color: "#666" }}>
                Leo Haas - Der Hölle entronnen<br />
                Erschienen im Henschelverlag, 1985
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
